// import { HelpCircle } from 'lucide-react'

export default function Helps() {
  // 暫時隱藏操作說明按鈕
  return null

  /* 原始代碼
  return (
    <div className="px-6 py-4">
      <button className="group flex items-center w-full px-3 py-2 text-sm font-medium text-gray-700 rounded-md hover:bg-gray-200 focus:outline-none">
        <HelpCircle className="w-4 h-4 mr-2 stroke-gray-500 group-hover:stroke-gray-700" />
        操作說明
      </button>
    </div>
  )
  */
}
